import React, { useContext } from 'react';
import { Button, Col, Row } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import Paragraph from '../../../../components/common/Paragraph';
import { EnrollmentContext } from '../../../../providers/EnrollmentContextProvider';
import formCol from '../../../../utils/formCol';
import form from '../../../../utils/form';

const FinalStep = () => {
  const { postulantEmail, postulantRut, trackingNumber } = useContext(EnrollmentContext);

  const history = useHistory();

  const goToTracking = () => {
    history.push(`/enrolamiento/seguimiento?trackingNumber=${trackingNumber}&rut=${postulantRut}`);
  };

  const exit = () => {
    sessionStorage.clear();
    history.go(0);
  };

  return (
    <Row justify="center">
      <Col {...formCol.responsive}>
        <Paragraph strong align="center">
          Solicitud de cliente realizada con éxito
        </Paragraph>
        <Row justify="center">
          <Col>
            <CheckCircleOutlined
              style={{ fontSize: '5.5rem', color: '#cccccc', marginBottom: '1.8rem' }}
            />
          </Col>
        </Row>
        <Paragraph noBottomMargin={!!postulantEmail} align="center">
          Gracias por registrar una nueva solicitud de cliente. Te enviaremos un email con toda la
          información a:
        </Paragraph>
        {postulantEmail && (
          <Paragraph align="center" strong>
            {postulantEmail}
          </Paragraph>
        )}
      </Col>
      <Col
        span={24}
        style={{ backgroundColor: '#f5f5f5', padding: '1.5rem 0', marginBottom: '1rem' }}
      >
        <Paragraph align="center" noBottomMargin>
          Número de solicitud <b>{form.normalizers.trackingNumber(trackingNumber.toString())}</b>
        </Paragraph>
        <Button type="link" style={{ padding: '0' }} block onClick={goToTracking}>
          <Paragraph noBottomMargin underline align="center">
            Seguimiento en línea de la solicitud
          </Paragraph>
        </Button>
      </Col>
      <Col span={24}>
        <Button type="primary" block onClick={exit}>
          Entendido
        </Button>
      </Col>
    </Row>
  );
};

export default FinalStep;
